import React from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiChip from '@material-ui/core/Chip';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { useRouter } from 'next/router';
import { withStyles } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import qs from 'query-string';
import AutoComplete from 'src/components/Common/AutoComplete';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  content: {
    alignItems: 'center',
  },
})(MuiExpansionPanelSummary);

const PanelHeading = withStyles({
  h6: {
    width: '100%',
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
const Chip = styled(MuiChip)`
  font-size: 10px !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`;

type LocationPanel = {
  isWantedSearch: boolean;
};
const LocationPanel = ({ isWantedSearch }: LocationPanel) => {
  const router = useRouter();
  const { query } = router;
  const [location, setLocation] = React.useState('');

  /*  const handleChange = (address) => {
    setLocation({ ...location, address });
  };
  const handleSelect = (address) => {
    /!* geocodeByAddress(address)
      // .then((results) => getLatLng(results[0]))
      .then((results) => {})
      .then((latLng) => {
        console.log('Success', latLng);
      })
      .catch((error) => console.error('Error', error)); *!/
    setLocation({
      activeLocation: address,
      address,
    });
    query.location = address;
    router.push(`/search?${qs.stringify(query)}`);
  }; */
  const onDelete = () => {
    setLocation('');
    delete query.location;
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(query)}`);
    } else {
      router.push(`/search?${qs.stringify(query)}`);
    }
  };
  const [expanded, setExpanded] = React.useState(true);

  const handleLocationChange = (val: string | null) => {
    if (val) {
      // const locationString = val.trim().split(' ').join('');
      setLocation(val);
      query.location = val;
      if (isWantedSearch) {
        router.push(`/wanted-search?${qs.stringify(query)}`);
      } else {
        router.push(`/search?${qs.stringify(query)}`);
      }
    } else setLocation('');
  };

  const handlePanelChange = (event: any, isExpanded: boolean) => {
    setExpanded(!!isExpanded);
  };

  return (
    <ExpansionPanel defaultExpanded expanded={expanded} onChange={handlePanelChange}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <PanelHeading variant="h6">By Location</PanelHeading>
        {query.location && (
          <Chip size="small" label={query.location} onDelete={() => onDelete()} color="primary" />
        )}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {/* <PlacesAutocomplete
          onSelect={handleSelect}
          onChange={handleChange}
          value={location.address}
          debounce={400}
          // onError={(error) => {}}
          searchOptions={{
            types: ['(cities)'],
            componentRestrictions: {
              country: 'pk',
            },
          }}
          // shouldFetchSuggestions={location.address.length > 2}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div>
              <TextField
                {...getInputProps({
                  placeholder: 'Search Places ...',
                  className: 'location-Search-input',
                })}
              />
              <div className="autocomplete-dropdown-container">
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion, index) => {
                  const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div
                      key={index}
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete> */}
        {/* <GoogleMaps /> */}
        <AutoComplete
          label={(query.location && 'Change a location') || 'Add a location'}
          onChangeHandler={handleLocationChange}
          value={location}
          style={{ width: '100%' }}
        />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default LocationPanel;
